import { render, staticRenderFns } from "./IncreaseStorageQuota.vue?vue&type=template&id=57d768b7&"
import script from "./IncreaseStorageQuota.vue?vue&type=script&lang=js&"
export * from "./IncreaseStorageQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports